import axios from "axios";

const sendVerificationCode = async (email: string) => {
  const response = await axios.post("/api/Register/SendVerificationCode", {
    email,
  });

  return response.data;
};

const confirmVerificationCode = async (request: any) => {
  const response = await axios.post(
    "/api/Register/ConfirmVerificationCode",
    request
  );

  return response.data;
};

const register = async (request: any) => {
  const response = await axios.post("/api/Register/Register", request);

  return response.data;
};

const SignUpService = {
  sendVerificationCode,
  confirmVerificationCode,
  register,
};

export default SignUpService;
